import React, { useState, useEffect } from 'react';
import './Counts.css';

const Counts = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const stored = parseInt(localStorage.getItem('toolbox_visit_count') || '0', 10);
    setCount(stored);
  }, []);

  return (
    <div className="counts-page">
      <div className="counts-card">
        <div className="counts-label">工具箱访问次数</div>
        <div className="counts-number">{count.toLocaleString()}</div>
        <div className="counts-sub">每次访问 /toolbox 页面计一次</div>
      </div>
    </div>
  );
};

export default Counts;
